namespace GeniuzPOS.InitialData {
    export interface PsPurposeReasonForm {
        PurposeCode: Serenity.StringEditor;
        Purpose: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
        DocType: Serenity.LookupEditor;
    }

    export class PsPurposeReasonForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsPurposeReason';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsPurposeReasonForm.init)  {
                PsPurposeReasonForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(PsPurposeReasonForm, [
                    'PurposeCode', w0,
                    'Purpose', w0,
                    'Remark', w0,
                    'DocType', w1
                ]);
            }
        }
    }
}
